import { createAction, props } from '@ngrx/store';
import { ChatMessage } from '@twaice-fe/shared/models';

export const fetchChatMessages = createAction('[Chat/API] Fetch chat messages');

export const loadChatMessagesSuccess = createAction(
  '[Chat/API] Load chat messages success',
  props<{ messages: ChatMessage[] }>()
);

export const loadChatMessagesFailure = createAction('[Chat/API] Load chat messages failure', props<{ error: string }>());

export const postChatMessage = createAction(
  '[Chat/API] Post chat message',
  props<{
    message: string;
    tags: string[];
    includeLink: boolean;
    parent?: string;
    relatedEntities?: string[];
    timestamp?: Date;
  }>()
);

export const postChatMessageSuccess = createAction('[Chat/API] Post chat message success', props<{ message: ChatMessage }>());

export const postChatMessageFailure = createAction('[Chat/API] Post chat message failure', props<{ error: string }>());

export const patchChatMessage = createAction(
  '[Chat/API] Patch chat message',
  props<{ customerBk: string; systemBk: string; timestamp: string; message?: string; tags?: string[] }>()
);

export const patchChatMessageSuccess = createAction('[Chat/API] Patch chat message success', props<{ message: ChatMessage }>());

export const patchChatMessageFailure = createAction('[Chat/API] Patch chat message failure', props<{ error: string }>());

export const deleteChatMessage = createAction(
  '[Chat/API] Delete chat message',
  props<{ customerBk: string; systemBk: string; timestamp: string }>()
);

export const deleteChatMessageSuccess = createAction('[Chat/API] Delete chat message success', props<{ timestamp: string }>());

export const deleteChatMessageFailure = createAction('[Chat/API] Delete chat message failure', props<{ error: string }>());
